import { userSelector } from '../app/main/mainSlice'
import { useAppDispatch, useAppSelector } from '../app/store/hooks'
import { GET_USER_NUTRITIONAL_TARGET } from '../app/graphql/queries'
import { useQuery } from '@apollo/client'
import { NutritionalTargetSelector, setNutritionalTarget } from '../app/mealPlan/mealPlan.slice'
import { UseGetFlag } from '../app/launchDarkly'

const useFetchNutritionalTargets = (selectedDate: Date) => {
    const user = useAppSelector(userSelector)
    const dispatch = useAppDispatch()
    const { enableMealPlanChallenge } = UseGetFlag();
    const currentNutritionalTarget = useAppSelector(NutritionalTargetSelector);
    const { loading: nutrionalTargetDataLoading, refetch: refetchNutrionalTarget } = useQuery(GET_USER_NUTRITIONAL_TARGET, {
        variables: {
            user_id: user?.id,
            selectedDate
        },
        skip: !user?.id || !enableMealPlanChallenge,
        onCompleted: (data) => {
            if (data?.User_To_Nutritional_Info) {
                const newTarget = data.User_To_Nutritional_Info[0];
            
                if (!isEqual(currentNutritionalTarget, newTarget)) {
                    dispatch(setNutritionalTarget(newTarget));
                }
            }
        },
        onError: (err) => {
            console.error(err)
        }
    })

    const refetch = async () => {
        const data = await refetchNutrionalTarget();
        if (data?.data?.User_To_Nutritional_Info) {
            const newTarget = data.data.User_To_Nutritional_Info[0];
                if (!isEqual(currentNutritionalTarget, newTarget)) {
                    dispatch(setNutritionalTarget(newTarget));
                }
        }
    }

    const isEqual = (a: any, b: any) => {
        if (a === b) return true;
        if (!a || !b) return false;
        return JSON.stringify(a) === JSON.stringify(b);
    };

    return { nutrionalTargetDataLoading, refetchNutrionalTarget: refetch }
}

export default useFetchNutritionalTargets;
